import 'whatwg-fetch';

import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON,isOk,authReq} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function commonAlert(text, prompt = null, theme = null, nav = null) {
  return {
    type: constants.COMMON_ALERT,
    text,
    prompt,
    theme,
    nav
  };
}

export function commonCloseAlert() {
	return {
    type: constants.COMMON_CLOSE_ALERT,
  };
}

export function commonModalResize() {
	return {
    type: constants.COMMON_MODAL_RESIZE,
  };
}

export function commonOpenContact(text) {
  return {
    type: constants.COMMON_OPEN_CONTACT,
  };
}

export function commonCloseContact() {
  return {
    type: constants.COMMON_CLOSE_CONTACT,
  };
}

export function commonNotify() {
  return {
    type: constants.COMMON_NOTIFY,
  };
}

export function commonCloseNotify() {
  return {
    type: constants.COMMON_CLOSE_NOTIFY,
  };
}

export function commonOpenLogin() {
  return {
    type: constants.COMMON_OPEN_LOGIN,
  };
}

export function commonCloseLogin() {
  return {
    type: constants.COMMON_CLOSE_LOGIN,
  };
}

export function commonRegisterNavChange() {
  return {
    type: constants.COMMON_NAV_CHANGE,
  };
}



/******************************
*******  Asynchronous  ********
******************************/


export function commonContactRequest(contactData) {
  return dispatch => {
    let url = api.API_URL + endpoint.API_CONTACT;


    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(contactData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function commonFoundationRequest(foundationData) {
  return dispatch => {
    let url = api.API_URL + endpoint.API_FOUNDATION;


    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(foundationData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function commonShoppingRequest(shoppingData) {
  return dispatch => {
    let url = api.API_URL + endpoint.API_SHOPPING;

    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(shoppingData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function commonServiceRequest(serviceData) {
  return dispatch => {
    let url = api.API_URL + endpoint.API_SERVICE;

    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(serviceData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function commonWatchRequest(watchData) {
  return dispatch => {
    let url = api.API_URL + endpoint.API_WATCH;


    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(watchData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function commonGetInstagram(watchData) {
  return dispatch => {
    let url = endpoint.INSTAGRAM_GET_IMAGES;

    return fetch(url, {
      method: 'get',
      headers: api.HEADERS,
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function commonSummerContactRequest(contactData) {
  return dispatch => {
    let url = api.API_URL + endpoint.API_SUMMER_CONTACT;

    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(contactData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function commonAuburnContactRequest(contactData) {
  return dispatch => {
    let url = api.API_URL + endpoint.API_AUBURN_CONTACT;

    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(contactData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function commonCustomDesignContactRequest(contactData) {
  return dispatch => {
    let url = api.API_URL + endpoint.API_CUSTOM_DESIGN;

    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(contactData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

// export function commonNewsletterSubmit(email) {
//   return dispatch => {
//     let url = 'https://diamondsdirect.com/newsletter/subscriber/new/';

//     const params = new FormData();
//     params.append('email', email.trim());

//     return fetch(url, {
//       method: 'post',
//       headers: api.HEADERS,
//       body: params
//     })
//     .then(parseJSON)
//     .then((resp) => {
//       if(isOk(resp.status)) {
//         return Promise.resolve(resp.data);
//       } else {
//         return Promise.reject(resp.data);
//       }
//     });
//   }
// }



// WEBPACK FOOTER //
// ./src/actions/common.jsx